import { useDrawer } from '../inc-drawer/inc-drawer.hooks';
import { CustomerQuickDetailsDrawerDataType } from './customer-quick-details-drawer.component';

export const useCustomerQuickDetailsDrawer = () =>
  useDrawer<CustomerQuickDetailsDrawerDataType>();
